import apiClient from '@/services/api_client_saas.js'

export const state = {
  languages: {},
  sources: [], // list of all the input (source) language codes
  targets: {}, // for each input language, a list of the available target languages
  flags: {}, // language-code to lowercase country code map for flag icons
  qtSources: [], // list of input language codes for Quick Translate only
  qtTargets: {} // mapping of destination languages for Quick Translate only
}

export const mutations = {
  SET_LANGUAGES (state, value) {
    state.languages = value
  },
  SET_SOURCES (state, value) {
    state.sources = value
  },
  SET_TARGETS (state, value) {
    state.targets = value
  },
  SET_FLAGS (state, value) {
    state.flags = value
  },
  SET_QT_SOURCES (state, value) {
    state.qtSources = value
  },
  SET_QT_TARGETS (state, value) {
    state.qtTargets = value
  }
}

export const getters = {
  flags: state => {
    return state.flags
  },
  languages: state => {
    return state.languages
  },
  sourceLanguages: state => {
    return state.sources.map(
      function (key, index) {
        return {
          code: key,
          label: state.languages[key],
          flag: state.flags[key]
        }
      })
  },
  targetLanguages: state => id => {
    if (!id) { return [] }
    return state.targets[id].map(
      function (key, index) {
        return {
          code: key,
          label: state.languages[key],
          flag: state.flags[key]
        }
      })
  },
  qtSourceLanguages: state => {
    return state.qtSources.map(
      function (key, index) {
        return {
          code: key,
          label: state.languages[key],
          flag: state.flags[key]
        }
      })
  },
  qtTargetLanguages: state => id => {
    if (!id) { return [] }
    return state.qtTargets[id].map(
      function (key, index) {
        return {
          code: key,
          label: state.languages[key],
          flag: state.flags[key]
        }
      })
  }
}

export const actions = {
  loadLanguages ({ state, commit, rootState }) {
    if (!state.sources.length) {
      return apiClient
        .get('/services/translate')
        .then(response => {
          this.commit('SET_LANGUAGES', response.data.languages)
          this.commit('SET_SOURCES', response.data.sources)
          this.commit('SET_TARGETS', response.data.targets)
          this.commit('SET_FLAGS', response.data.flags)
          this.commit('SET_QT_SOURCES', response.data.qt_sources)
          this.commit('SET_QT_TARGETS', response.data.qt_targets)
        })
        .catch(err => {
          console.log(`Unable to retrieve data: ${err}`)
          return Promise.reject(err)
        })
    } else {
    }
  }
}
